import { ENVS as SDK_ENVS } from '@adsk/bim360-rfis-sdk';
import { ISSUES_ENV_TYPES } from '../../../constants/envs';

export const ATTACHMENT_SORT = 'createdAt DESC';

export const MAX_LIMIT = 200;
export const DEFAULT_LIMIT = 20;

export const getSdkEnv = (rfiEnv) => {
  let sdkEnv = SDK_ENVS.PRODUCTION;
  if (rfiEnv === ISSUES_ENV_TYPES.LOCAL || rfiEnv === ISSUES_ENV_TYPES.QA) {
    sdkEnv = SDK_ENVS.QA;
  }
  if (rfiEnv === ISSUES_ENV_TYPES.STAGING) {
    sdkEnv = SDK_ENVS.STAGING;
  }
  if (rfiEnv === ISSUES_ENV_TYPES.PROD) {
    sdkEnv = SDK_ENVS.PRODUCTION;
  }
  return sdkEnv;
};
